
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import { useCallback, useEffect, useState } from 'react';
import Styles from './styles/AddOffer.module.css'
import DialogContent from '@mui/material/DialogContent';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Helper from './Helper';
import Confirmation from './Confirmation';
import Typography from '@mui/material/Typography';
import { capitalizeText } from '../utils/strings';
import { uid } from "uid";
import Schedule from './NewSchedule';
import EasySnackBar from './EasySnackBar';
import { SCHEDULE_BASE } from '../utils/dates';

export default function AddOffer(props) {
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [offerProducts, setOfferProducts] = useState([])
    const [open, setOpen] = useState(false)

    const [schedule, setSchedule] = useState(SCHEDULE_BASE);

    const [offerID, setOfferID] = useState("");
    const [name, setName] = useState("");
    const [privateName, setPrivateName] = useState("");

    const [errorMessage, setErrorMessage] = useState('')

    const [priceChange, setPriceChange] = useState(0)

    useEffect(() => {
        if (props.offer) {
            setOfferID(props.offer.id)
            setName(props.offer.name)
            setPrivateName(props.offer.privateName)
            setPriceChange(props.offer.priceChange)
            setSchedule(props.offer.schedule)
            setOfferProducts(props.offer.products ? Object.values(props.offer.products) : [])
        }
    }, [props.offer])

    const handleToggle = (value) => () => {
        const currentIndex = offerProducts.indexOf(value);
        const newChecked = [...offerProducts];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setOfferProducts(newChecked);
    };

    const restartDataStates = useCallback(() => {
        setOfferID("")
        setName("")
        setPrivateName("")
        setPriceChange(0)
        setSchedule(SCHEDULE_BASE)
        setOfferProducts([])
        setOpen(false)
    }, [])

    const updateOffer = ID => {
        if (name !== props.offer.name
            || privateName !== props.offer.privateName
            || priceChange !== props.offer.priceChange
            || schedule !== props.offer.schedule
            || offerProducts.sort().join(',') !== Object.values(props.offer.products).sort().join(',')) {

            let aux = [...props.offers]
            const index = aux.findIndex(elem => elem.id === ID)

            aux[index] = { id: ID, name: capitalizeText(name), privateName: privateName, priceChange: parseFloat(priceChange), schedule: schedule, products: offerProducts }

            props.setOffers(aux)
            props.onUpdate(aux)
        }

        setOpen(false)
    }

    const addOffer = () => {
        if (name === '') {
            setErrorMessage('La promoción debe tener un nombre')
            return
        }
        if (priceChange === 0) {
            setErrorMessage('La promoción debe incluir % de descuento')
            return
        }
        const aux = props.offers.concat({ id: uid(), name: capitalizeText(name), privateName: privateName, priceChange: parseFloat(priceChange), schedule: schedule, products: offerProducts })

        props.setOffers(aux)
        props.onUpdate(aux)

        restartDataStates()
    }

    const removeOffer = useCallback(ID => {
        const aux = props.offers.filter(elem => elem.id !== ID)

        props.setOffers(aux)
        props.onUpdate(aux)
        restartDataStates()
    }, [props, restartDataStates])

    return (
        <>
            {offerID === '' ?
                <Button
                    variant='outlined'
                    onClick={setOpen.bind(this, true)}
                    size='large'
                    sx={{ m: 2 }}
                >
                    Crear nueva promocion
                </Button> :
                <>
                    <ListItem disablePadding>
                        <ListItemButton onClick={setOpen.bind(this, true)}>
                            <ListItemText
                                primary={name}
                                secondary={"Productos: " + offerProducts.length + " | Descuento: " + priceChange * 100 + "%"}
                            />
                        </ListItemButton>
                    </ListItem>
                    <Divider />
                </>}

            <Dialog open={open} onClose={setOpen.bind(this, false)} fullScreen>
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={setOpen.bind(this, false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Administrar promocion
                        </Typography>

                        <Stack
                            direction="row"
                            flexWrap="wrap"
                            justifyContent="center"
                            alignItems="center"
                        >
                            {offerID === "" ?
                                <Button autoFocus color="error" variant='contained'
                                    onClick={setShowConfirmation.bind(this, true)}
                                    sx={{ margin: '10px' }}
                                >
                                    Descartar
                                </Button> :
                                <Button autoFocus color="error" variant='contained'
                                    onClick={setShowConfirmation.bind(this, true)}
                                    sx={{ margin: '10px' }}
                                >
                                    Eliminar
                                </Button>}

                            <Button autoFocus color="success" variant='contained'
                                onClick={offerID !== "" ? updateOffer.bind(this, offerID) : addOffer.bind(this)}
                                sx={{ margin: '10px' }}
                            >
                                {offerID !== "" ? "Actualizar" : "Guardar"}
                            </Button>
                        </Stack>
                    </Toolbar>
                </AppBar>

                <DialogContent sx={{ padding: '25px 0px 75px 0px' }}>
                    <div className={Styles.container}>

                        <Stack
                            direction='row'
                            justifyContent='flex-start'
                            flexWrap='wrap'
                            gap='15px'
                        >
                            <TextField
                                required
                                label="Nombre de la promocion"
                                fullWidth
                                value={name}
                                onChange={e => { if (e.target.value.length < 150) { setName(e.target.value) } }}
                                helperText='Maximo 150 caracteres'
                            />

                            <TextField
                                required
                                label="% de descuento"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                                value={parseInt(priceChange * 100)}
                                onChange={e => e.target.value < 100 && e.target.value >= 0 ? setPriceChange(e.target.value / 100) : null}
                            />

                            <TextField
                                label="Nombre para uso interno"
                                fullWidth
                                value={privateName}
                                onChange={e => { if (e.target.value.length < 150) { setPrivateName(e.target.value) } }}
                                helperText='Maximo 150 caracteres'
                            />

                        </Stack>

                        <Divider sx={{ m: 1 }} />

                        <Typography variant='h4' sx={{ m: 1 }}>
                            Horarios de la promoción
                        </Typography>

                        <Schedule schedule={schedule} setSchedule={setSchedule} />

                        <Divider sx={{ m: 1 }} />

                        <Typography variant='h4' sx={{ m: 1 }}>
                            Productos
                            <Helper text='Selecciona lo productos que serán incluidos en la promoción' />
                        </Typography>

                        <List>
                            {!props.products ? null : props.products.map((product, index) => {
                                const labelId = `checkbox-list-label-${product[0]}`;
                                const isInAnotherOffer = product[1].offer ? product[1].offer !== offerID ? true : false : false
                                const newPrice = (parseFloat(product[1].price) - (parseFloat(product[1].price) * parseFloat(priceChange))).toFixed(2)

                                return (
                                    <div key={index}>
                                        <ListItem disablePadding>
                                            <ListItemButton role={undefined} onClick={handleToggle(product[0])} dense
                                                disabled={isInAnotherOffer}
                                            >
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={offerProducts.indexOf(product[0]) !== -1}
                                                        tabIndex={-1}
                                                        disableRipple
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </ListItemIcon>
                                                <ListItemText id={labelId}
                                                    primary={product[1].name}
                                                    secondary={isInAnotherOffer ?
                                                        'Este producto ya se encuentra en otra promoción' :
                                                        'Actual $' + product[1].price +
                                                        ' -> Con el descuento $' + newPrice} />
                                            </ListItemButton>
                                        </ListItem>
                                        <Divider />
                                    </div>
                                )
                            })}
                        </List>

                    </div>
                </DialogContent>
            </Dialog>

            {props.offer ?
                <Confirmation
                    action={() => removeOffer(offerID)}
                    open={showConfirmation}
                    setOpen={setShowConfirmation}
                    title={"Estas a punto de eliminar tu promoción"}
                    description={"Estas seguro de que quieres la promoción? Se perderá toda la configuracion de la promoción"}
                    actionMsg={"Eliminar"}
                    rejectMsg={"Volver"}
                /> :
                <Confirmation
                    action={restartDataStates}
                    open={showConfirmation}
                    setOpen={setShowConfirmation}
                    title={"Estás seguro de que quieres descartar los cambios?"}
                    description={""}
                    actionMsg={"Descartar"}
                    rejectMsg={"Volver"}
                />}

            <EasySnackBar
                severity='error'
                key='1'
                message={errorMessage}
                setMessage={setErrorMessage}
            />
        </>
    )
}